import { api_DELETE, api_GET, api_POST, api_PUT } from './_api';

const redestinacao_api = {
    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Redestinacao/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetListReceberResiduos: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Redestinacao/GetListReceberResiduos`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Redestinacao/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Redestinacao/`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    PostListDestinosPorModalidade: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Redestinacao/PostListDestinosPorModalidade/`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    PostListVeiculosTransportadoresModalidade: (transportador_Id, obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Redestinacao/PostListVeiculosTransportadoresModalidade/${transportador_Id}`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    PostListTransportadoresModalidade: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Redestinacao/PostListTransportadoresModalidade`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result))
        });
        return promise;
    },
    InsertRedestinacaoResiduo: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Redestinacao/InsertRedestinacaoResiduo`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Redestinacao/`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    EnviarResiduo: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Redestinacao/EnviarResiduo`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    DeletaRedestinacao: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_DELETE(`Redestinacao/DeletaRedestinacao/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default redestinacao_api;